import { AfterContentChecked } from '@angular/core';
import { AfterViewChecked, AfterViewInit, Component, OnInit, Pipe, PipeTransform , ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from "lodash";
import { element } from 'protractor';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationsService } from 'src/app/Service/publications.service';
import { SharedService } from 'src/app/Service/shared.service';
declare var $: any

@Component({
  selector: 'app-appel-consurrence2',
  templateUrl: './appel-consurrence2.component.html',
  styleUrls: ['./appel-consurrence2.component.scss']
})
export class AppelConsurrence2Component implements OnInit {

  @ViewChild('myModal', { static: false }) myModal: any;

  Region: any[];
  Categorie: any[];
  // Download form fields
  fullName: string = '';
  personQuality: string = '';
  email: string = '';
  companyName: string = '';
  companyAddress: string = '';
  companyPhone: string = '';
  terms: boolean = false;
  error: string = '';

  download : boolean=false;

  constructor(private global: Global, private service: PublicationsService, private shared: SharedService, private route: ActivatedRoute,private router: Router,private translate: TranslateService) { }
  currentlang = '';
  currentUrl;
  outputLg;
  slick: any = null;
  dataOffres;
  Id;
  isclicked = false;
  selectedOffre;
  OffresGlobals = [];
  dataOffresbrute = [];
  filter = {};
  description;
  descriptionFooter;
  langue;
  lenth;
  isArab=false;
  dossierReady :boolean;

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.isArab = lg.code == "ar";
      this.outputLg = lg;
      this.currentlang = lg.url;
      this.currentUrl = this.router.url
      this.langue = lg;
      this.route.params.subscribe(params => {
        this.Id = params["Id"];
        if (this.Id) {
          this.isclicked = true;
          this.service.getAConcurrenceId(lg.url, this.Id).subscribe(data => {
            //console.log(data)
            this.selectedOffre = data["value"][0];
            this.service.DownloadACDossier().subscribe(
              (data) => {
                
                const dataFile = data["value"].filter(item => item.ListItemAllFields.Appel_x0020__x00e0__x0020_ConcurrenceId == this.Id)[0];
                //console.log('testtest',dataFile)
                if(dataFile){
                 this.dossierReady = true;
                }
                else{
                  this.dossierReady = false;
                }
                
                
               // window.open(this.global._basedUrl + data["value"][0].ServerRelativeUrl);
                
              }
            );
          })
        } else {
          this.isclicked = false;
          this.dataOffres = [];
          this.service.getAConcurrences(lg.url).subscribe(data => {
            this.service.getRegions().subscribe(reg => {
              this.Region = reg["value"];
            })
            this.Categorie = _.uniq(_.flatMap(data["value"], ({ Domaine }) => Domaine));
            this.OffresGlobals = data["value"];
            this.lenth=this.OffresGlobals.length;
            this.dataOffres = this.OffresGlobals.filter(element => {return  element["Programme_region"]!=true});
            // this.dataOffres = this.OffresGlobals.filter(element => {return  element["Programme_region"]===false});
            this.dataOffresbrute = this.dataOffres;
            if (this.slick != null) {
              this.reload();
            } else {
              setTimeout(() => this.sliderAppel(), 100);
            }
          })
        }
      })
      this.shared.getBlocDescriptionByCode(lg.url, "appelconcurrence").subscribe(data => {
        this.description = data["value"][0];
      })
    })
  }


  converteDate(d: string) {
    return this.global.formattedDate(d);
  }
  capitize(string)
  {
    if(string) {
      return string.charAt(0) + string.slice(1).toLowerCase();
    }
    return null;
  }
  sliderAppel() {
    this.slick = $('#offres').dataTable({
      data: this.dataOffres,
      columns: [
        { data: 'Title' },
        { data: "Objet",
          render: (data, type, row) => {
            return this.capitize(data)
          } 
        },
        { data: "Etape"},
        {
          data: 'Date_x0020_Ouverture',
          render: (data, type, row) => {
            return this.converteDate(data);
          }
        }
      ],
      columnDefs: [{ 'targets': 2, type: 'date-euro' }],
      "language": {
        "paginate": {
          "previous":'«',
          "next":'»'
        }
      },
      "searching": false,
      "info": false,
      "lengthChange": false,
      "order": []
    });
    var b = this.router;
    $('#offres tbody').on('click', 'tr',function(e){
      var data = $('#offres').DataTable().row(this).data();
      b.navigate(["services/appel-concurrence2/"+data.ID]);
    });
  }
  reload() {
    $('#offres').DataTable().clear();
    $('#offres').DataTable().rows.add(this.dataOffres);
    $('#offres').DataTable().columns.adjust().draw();
  }
  lancerFilter(filter) {
    this.filter = filter;
    this.dataOffres = [];
    if(filter.Objet== '' &&  filter.Region == '' && filter.Domain ==  ''&& filter.DatePlis == ''){
      this.dataOffres = this.dataOffresbrute;
    }else{
      this.dataOffres = this.transform(this.OffresGlobals, filter);
    }
    this.lenth = this.dataOffres.length;
    if (this.slick != null) {
      this.reload();
    } else {
      setTimeout(() => this.sliderAppel(), 100);
    }
  }
  transform(objet, filters): any[] {
    return objet.filter(element => {
      let a = true;
      filters.Objet && element['Objet']? a = a && ((element['Objet'] as string).toUpperCase().includes(filters.Objet.toUpperCase()) || (element['Objet_ar'] as string).toUpperCase().includes(filters.Objet.toUpperCase())) : null;
      filters.Region && filters.Region != '' ? a = a && filters.Region == element['RegionId'] : null;
      filters.Domain && filters.Domain != '' ? a = a && filters.Domain == element['Domaine'] : null;
      filters.DatePlis && filters.DatePlis != '' ? a = a && new Date(filters.DatePlis).toLocaleDateString('fr') == new Date(element['Date_x0020_Ouverture']).toLocaleDateString('fr') : null;
      return a;
    });
  }


  onSubmit(form: any) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(this.email)) {
      this.error = 'Veuillez entrer une adresse email valide.';
      return;
    }
  
    const phoneRegex = /^(\+\d{1,2}\s?)?1?\-?\s?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{4}$/;
    if (!phoneRegex.test(this.companyPhone)) {
      this.error = 'Veuillez entrer un numéro de téléphone valide.';
      return;
    }
  
    if (!this.fullName || !this.personQuality || !this.email || !this.companyName || !this.companyAddress || !this.companyPhone || !this.terms) {
      this.error = 'Veuillez remplir tous les champs correctement.';
      return;
    }
  
    if (form.valid) {
      // Prepare the data to send to SharePoint
      const postData = {
        "__metadata": {
          "type": "SP.Data.Historique_x0020_Appel_x0020_candidaturesListItem"
        },
        Title: this.fullName,
        Qualit_x00e9__x0020_de_x0020_la_: this.personQuality,
        Email: this.email,
        Raison_x0020_sociale: this.companyName,
        Adresse_x0020_entreprise: this.companyAddress,
        T_x00e9_l_x00e9_phone: this.companyPhone,
        ID_x0020_ACId: this.Id
      };
  
      // Fetch the X-RequestDigest token before making the POST request
      this.service.getRequestDigest().subscribe(
        (response: any) => {
          const requestDigest = response.FormDigestValue;
  
          // Now make the POST request to add the item
          this.service.AddAppelConcurranceClient(postData, requestDigest).subscribe(
            (response) => {
              // After adding the item, download the dossier
              this.service.DownloadACDossier().subscribe(
                (data) => {
                  
                  const dataFile = data["value"].filter(item => item.ListItemAllFields.Appel_x0020__x00e0__x0020_ConcurrenceId == this.Id)[0];
                  if(dataFile){
                    window.open(this.global._basedUrl + dataFile.ServerRelativeUrl);
                    $('#myModal').modal('hide');
                  }
                  else{
                    this.error = 'Erreur lors du téléchargement du dossier, veuillez réessayer.';
                    return;
                  }
                  
                  
                 // window.open(this.global._basedUrl + data["value"][0].ServerRelativeUrl);
                  
                }
              );
            },
            (error) => {
              console.error('Error posting data:', error);
              // Handle errors (e.g., show error message)
            }
          );
        },
        (error) => {
          console.error('Error fetching X-RequestDigest:', error);
          // Handle errors in retrieving the digest
        }
      );
    } else {
      this.error = 'Veuillez remplir tous les champs correctement.';
    }
  }
  
}

@Pipe({ name: 'offresFilter' })
export class OffresFilterPipe implements PipeTransform {
  transform(objet: [], filters: any): any[] {
    return objet.filter(element => {
      let a = true;
      filters.Objet ? a = a && (element['Objet'] as string).includes(filters.Objet.toUpperCase()) || (element['Objet_ar'] as string).toUpperCase().includes(filters.Objet.toUpperCase()) : null;
      filters.Region && filters.Region != '' ? a = a && filters.Region == element['RegionId'] : null;
      filters.Domain && filters.Domain != '' ? a = a && filters.Domain == element['Domaine'] : null;
      filters.DatePlis && filters.DatePlis != '' ? a = a && new Date(filters.DatePlis) == new Date(element['Date_x0020_Ouverture']) : null;
      return a;
    });
  }
}